import { render } from "./EmissionStatistics.vue?vue&type=template&id=3096ed41"
import script from "./EmissionStatistics.vue?vue&type=script&lang=js"
export * from "./EmissionStatistics.vue?vue&type=script&lang=js"

import "./EmissionStatistics.vue?vue&type=style&index=0&id=3096ed41&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__